import { t } from 'i18next'
import { z } from 'zod'
export const eventSeoSchema = z.object({
  metaTitle: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:metaTitle_length_error') as string,
    }),
  metaDescription: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:metaDescription_length_error') as string,
    }),
  canonical: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:canonical_length_error') as string,
    }),
  schemaMarkup: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:metaDescription_length_error') as string,
    }),
  metaImage: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    }),
  keywords: z
    .string({
      invalid_type_error: t('error:field_required') as string,
    })
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:metaKeyword_length_error') as string,
    }),
})

export type IEventSeoSchema = z.infer<typeof eventSeoSchema>
